import { CountryInfo } from '../types';

// Country flag mapping from the original application
export const COUNTRY_FLAGS: Record<string, string> = {
  'NL': '🇳🇱',
  'US': '🇺🇸',
  'UK': '🇬🇧',
  'GB': '🇬🇧',
  'DE': '🇩🇪',
  'FR': '🇫🇷',
  'BE': '🇧🇪',
  'ES': '🇪🇸',
  'IT': '🇮🇹',
  'CA': '🇨🇦',
  'AU': '🇦🇺',
  'CH': '🇨🇭',
  'AT': '🇦🇹',
  'JP': '🇯🇵',
  'CN': '🇨🇳',
  'SG': '🇸🇬',
  'HK': '🇭🇰',
  'KR': '🇰🇷',
  'IN': '🇮🇳',
  'TH': '🇹🇭',
  'MY': '🇲🇾',
  'ID': '🇮🇩',
  'PH': '🇵🇭',
  'VN': '🇻🇳',
  'TW': '🇹🇼',
  'AE': '🇦🇪',
  'SA': '🇸🇦',
  'RU': '🇷🇺',
  'BR': '🇧🇷',
  'MX': '🇲🇽',
  'ZA': '🇿🇦',
  'SE': '🇸🇪',
  'NO': '🇳🇴',
  'DK': '🇩🇰',
  'FI': '🇫🇮',
  'IE': '🇮🇪',
  'PL': '🇵🇱',
  'PT': '🇵🇹',
  'TR': '🇹🇷',
  'IL': '🇮🇱',
  'NZ': '🇳🇿',
  'LU': '🇱🇺',
  'CZ': '🇨🇿',
  'HU': '🇭🇺',
  'GR': '🇬🇷',
  'RO': '🇷🇴',
  'BG': '🇧🇬',
  'SK': '🇸🇰',
  'SI': '🇸🇮',
  'HR': '🇭🇷',
  'EE': '🇪🇪',
  'LT': '🇱🇹',
  'LV': '🇱🇻',
  'UA': '🇺🇦',
  'CL': '🇨🇱',
  'AR': '🇦🇷',
  'CO': '🇨🇴',
  'PE': '🇵🇪',
  'EG': '🇪🇬',
  'MA': '🇲🇦',
  'NG': '🇳🇬',
  'KE': '🇰🇪',
  'PK': '🇵🇰',
  'BD': '🇧🇩',
  'QA': '🇶🇦',
  'KW': '🇰🇼',
  'OM': '🇴🇲',
  'EXT': '🏢', // External shareholder icon
  'Unknown': '🏁'
};

export const getCountryFlag = (countryCode: string): string => {
  return COUNTRY_FLAGS[countryCode.toUpperCase()] || COUNTRY_FLAGS['Unknown'];
};

export const getCountryInfo = (countryCode: string): CountryInfo => {
  const code = countryCode.toUpperCase();
  return {
    code,
    flag: getCountryFlag(code),
    name: code // Could be expanded with full country names if needed
  };
};
